'use client';

export { NotFoundPage as default } from '~/components/NotFoundPage';
